module.exports = __webpack_public_path__ + "static/img/s1.1f41663e.jpg";